import { Module, Mutation, VuexModule, getModule } from "vuex-module-decorators";

import store from "@/store";
import { MIRA_COMPARISON_NONE, MiraComparisonMode } from "@/utils/MiraComparisonView";

const name = "miraComparison";

if (store.state[name]) {
  store.unregisterModule(name);
}

/**
 * The comparisons a user has chosen on the Mira screens, shared across every Mira section screen so the
 * choice survives a move from Trocknung to Geräte within one visit. Two are held independently (Hans,
 * #2610137, 2026-11-02): **upwards** (the Markt, a member's Gruppe) and **downwards** (the Mandanten of a
 * group, the Standorte), so both can be on at once.
 *
 * Deliberately **not persisted**: a comparison is a thing you turn on to look at and expect off again
 * next time, unlike the period. Both reset to "no comparison" on a reload.
 */
@Module({ dynamic: true, namespaced: true, store, name })
export class MiraComparisonVuexModule extends VuexModule {
  upward: MiraComparisonMode = MIRA_COMPARISON_NONE;

  downward: MiraComparisonMode = MIRA_COMPARISON_NONE;

  /**
   * The saved comparison chosen downwards (#2610137 tasks 22 / 24), or `null` for all the Mandanten /
   * Standorte. Read with {@link downward}: it applies only while that is the saved comparison's kind.
   */
  downwardSavedId: string | null = null;

  @Mutation
  setUpward(mode: MiraComparisonMode) {
    this.upward = mode;
  }

  /** Choose downwards: a kind with all its entities, or (with `savedId`) one of the user's saved comparisons. */
  @Mutation
  setDownward(payload: MiraComparisonMode | { mode: MiraComparisonMode; savedId: string | null }) {
    if (typeof payload === "string") {
      this.downward = payload;
      this.downwardSavedId = null;
      return;
    }
    this.downward = payload.mode;
    this.downwardSavedId = payload.savedId;
  }
}

export const MiraComparisonModule = getModule(MiraComparisonVuexModule);
